import { Winner } from '@/app/entities/Raffle'

interface RaffleWinnersProps {
  winners: Winner[]
}

export const RaffleWinners = ({ winners }: RaffleWinnersProps) => {
  const hasWinners = winners?.length > 0

  if (!hasWinners) {
    return null
  }

  return (
    <div>
      <h2 className="mb-4 text-2xl font-semibold">Vencedores</h2>
      {winners.map((winner) => (
        <div
          className="not flex w-full items-center gap-[10px] py-5"
          key={winner?._id}
        >
          <div className="rounded-md border bg-[#F7F7F7] p-[10px] font-semibold">
            {winner?.code}
          </div>
          {winner?.user?.name}
        </div>
      ))}
    </div>
  )
}
